import {Injectable} from '@angular/core';
import {ApiService} from '../../../../core/services/api.service';
import {Observable} from 'rxjs';
import {IPagination} from '../../../authorization/store/types';
import {exhaustMap, tap} from 'rxjs/operators';
import {IAttachment} from './types';
import {RolesService} from '../../../../core/services/roles.service';
import {AuthorizationState} from '../../../authorization/store/state';
import {Store} from '@ngxs/store';

@Injectable({
    providedIn: 'root'
})
export class MessagesService {
    constructor(private apiService: ApiService,
                private rolesService: RolesService,
                private store: Store) {
    }

    public fetchConversations(params): Observable<IPagination> {
        return this.apiService.get(`/messages/conversations`, params);
    }

    public fetchCompaniesList(params): Observable<any> {
        // Only ADMIN
        return this.apiService.get(`/messages/conversations/initialize/list`, params);
    }

    public fetchRoles(params): Observable<any> {
        if (this.rolesService.checkRoles(this.store.selectSnapshot(AuthorizationState.role), [this.rolesService.roles.ADMIN, this.rolesService.roles.ADMIN_USER_A, this.rolesService.roles.ADMIN_USER_B])) {
            // ADMIN MASTER
            return this.apiService.get(`/messages/conversations/contacts/list`, params);
        } else if (this.rolesService.checkRoles(this.store.selectSnapshot(AuthorizationState.role), [this.rolesService.roles.COMPANY, this.rolesService.roles.COMPANY_USER_A])) {
            // COMPANY
            return this.apiService.get(`/messages/conversations/initialize/list`, params);
        }

        // SUBCONTRACTOR
        // return this.apiService.get(`/messages/conversations/initialize/list`, params);
    }

    public fetchUsers(params): Observable<any> {
        if (this.rolesService.checkRoles(this.store.selectSnapshot(AuthorizationState.role), [this.rolesService.roles.ADMIN, this.rolesService.roles.ADMIN_USER_A, this.rolesService.roles.ADMIN_USER_B])) {
            // ADMIN MASTER
            return this.apiService.get(`/messages/conversations/contacts/list`, params);
        } else if (this.rolesService.checkRoles(this.store.selectSnapshot(AuthorizationState.role), [this.rolesService.roles.COMPANY, this.rolesService.roles.COMPANY_USER_A])) {
            // COMPANY MASTER
            return this.apiService.get(`/messages/conversations/contacts/list`, params);
        }

        // SUBCONTRACTOR
        // return this.apiService.get(`/messages/conversations/contacts/list?search=&page=1&group=____GROUP____`, params);
    }

    public fetchAllConversationMessages(id: string, params): Observable<IPagination> {
        return this.apiService.get(`/messages/conversations/${id}/messages`, params);
    }

    public fetchAllConversationAttachments(id: string): Observable<IAttachment[]> {
        return this.apiService.get(`/messages/${id}/attachments?days=365`);
    }

    public fetchMessageAttachment(url: string): Observable<any> {
        return this.apiService.downloadGet(`/uploads${url}`);
    }

    public createConversation(data): Observable<any> {
        return this.apiService.post(`/messages/conversations/new`, data);
    }

    public createMessageToConversation(data: any, id: string): Observable<any> {
        return this.apiService.post(`/messages/conversations/${id}/addMessage`, data);
    }

    public createMessageToConversationWithAttachment(data: any, id: string, file: File): Observable<any> {
        return this.apiService.post(`/messages/conversations/${id}/addMessage`, data).pipe(exhaustMap(response => {
            return this.addAttachmentToMessage(file, response._id);
        }));
    }

    private addAttachmentToMessage(file: File, id: string): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        return this.apiService.put(`/messages/addFile/${id}/files/attachment`, formData);
    }

    public attachFileToSubcontractor(messageId: string, fileId: string, subcontractorId: string, data: any): Observable<any> {
        return this.apiService.put(`/messages/assignFile/${messageId}/${fileId}/${subcontractorId}?property=other_files`, data);
    }

    public getUnreadConversations(): Observable<any> {
        return this.apiService.get(`/messages/conversations/unreadConversations/stats?type=public`);
    }

}
